import { isFiatCoin } from "util/formatter"

/**
 * What the transactions table shows in the "Method" column.
 *
 * A fiat withdrawal carries the rail it went through (PIX, OPENBANKING_SEPA, ...). Monolith rows
 * keep it inside the raw provider payload on `other`; financial-service rows keep it in a
 * first-class `payment_method` column and never write it to `other`. Read both.
 *
 * A crypto withdrawal has no rail — its method IS the coin it pays out in, which the Amount column
 * deliberately does not repeat. That fallback must stay crypto-only: a fiat row's coin is the
 * player's wallet currency, so falling back to it labels an OPENBANKING_SEPA payout "USD" — a
 * wrong answer where an empty cell is the truthful one.
 */
export function resolvePaymentMethodCell(row: {
  other?: { paymentMethod?: string | null } | null
  payment_method?: string | null
  method?: string | null
  coin?: string | null
}): string {
  const named = row?.other?.paymentMethod || row?.payment_method || row?.method
  if (named) return named
  return isFiatCoin(row?.coin) ? "" : row?.coin || ""
}
